export default __webpack_public_path__ + "static/media/incense.06648616.jpg";